// extracted by mini-css-extract-plugin
export default {"title":"SeventhScreen_title__gIgcK","description":"SeventhScreen_description__KHq3z","row":"SeventhScreen_row__SHObM"};